<template>
  <v-card :color="ui.cardColor" dark :max-width="ui.cardMaxWidth" :max-height="ui.cardMaxHeight">
    <v-card-title>
      <v-icon large left :color="ui.iconColor"> reorder </v-icon>
      <span :class="ui.textHeadline"> Activity Log </span>
    </v-card-title>

    <v-card-text class="ml-2">
      <div :class="ui.textDescription">
        Time record of activities completed by the system or users.
      </div>
    </v-card-text>

    <v-card-actions>
      <v-list-tile class="grow">
        <StatsReadCard :data="{tag: 'U1', size: 'flat'}"/>
        <StatsReadCardOpen :data="{tag: 'U1', size: 'icon'}"/>
        <v-spacer/>
        <GetDocumentLogListPage :data="{size: 'flat'}"/>
      </v-list-tile>
    </v-card-actions>
  </v-card>
</template>

<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import StatsReadCard from "@/support/stats/components/StatsReadCard";
import StatsReadCardOpen from "@/support/stats/components/StatsReadCardOpen";
import GetDocumentLogListPage from "@/document/log/components/GetDocumentLogListPage";
import licenceFunctions from "@/admin/functions/mixins/licenceFunctions.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
export default {
  components: {
    GetDocumentLogListPage,
    StatsReadCard,
    StatsReadCardOpen
  },
  mixins: [apptheme, licenceFunctions, adminFunctions],
  data() {
    return {
      valid: true
    };
  }
};
</script>
